import styled from '@emotion/styled'
import tw from 'twin.macro'

export const RegionListButton = styled('button')`
  ${tw`flex items-center justify-between py-3 border-b w-full text-left`}
`
